/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetClientExtendedDto
 */
export interface GetClientExtendedDto {
    /**
     * 
     * @type {string}
     * @memberof GetClientExtendedDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetClientExtendedDto
     */
    shortname: string;
    /**
     * 
     * @type {string}
     * @memberof GetClientExtendedDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetClientExtendedDto
     */
    nip: string;
    /**
     * 
     * @type {string}
     * @memberof GetClientExtendedDto
     */
    address: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientExtendedDto
     */
    active: boolean;
}

/**
 * Check if a given object implements the GetClientExtendedDto interface.
 */
export function instanceOfGetClientExtendedDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "shortname" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "nip" in value;
    isInstance = isInstance && "address" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function GetClientExtendedDtoFromJSON(json: any): GetClientExtendedDto {
    return GetClientExtendedDtoFromJSONTyped(json, false);
}

export function GetClientExtendedDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetClientExtendedDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'shortname': json['shortname'],
        'name': json['name'],
        'nip': json['nip'],
        'address': json['address'],
        'active': json['active'],
    };
}

export function GetClientExtendedDtoToJSON(value?: GetClientExtendedDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'shortname': value.shortname,
        'name': value.name,
        'nip': value.nip,
        'address': value.address,
        'active': value.active,
    };
}

